import { useEffect, useState } from 'react'
import RecoverPasswordProvider from '../../context/RecoverPasswordContext'
import ForgotPassword from './ForgotPassword'
import RecoveryCode from './RecoveryCode'
import NewPassword from './NewPassword'
import useLogout from '../../hooks/useLogout'
import useIsAuthenticated from 'react-auth-kit/hooks/useIsAuthenticated'

export enum RecoverAccountPage {
    FORGOT_PASSWORD = 'forgot password',
    RECOVERY_CODE = 'recovery code',
    NEW_PASSWORD = 'new password',
}

const RecoverPasswordPage = () => {
    const [page, setPage] = useState<RecoverAccountPage>(RecoverAccountPage.FORGOT_PASSWORD)
    const logout = useLogout()
    const isAuthenticated = useIsAuthenticated()

    useEffect(() => {
        if (isAuthenticated) logout()
    }, [logout, isAuthenticated])

    const renderPage = () => {
        switch (page) {
            case RecoverAccountPage.FORGOT_PASSWORD:
                return <ForgotPassword handleContinue={setPage} />
            case RecoverAccountPage.RECOVERY_CODE:
                return <RecoveryCode handleContinue={setPage} />
            case RecoverAccountPage.NEW_PASSWORD:
                return <NewPassword />
            default:
                return <></>
        }
    }

    return <RecoverPasswordProvider>{renderPage()}</RecoverPasswordProvider>
}

export default RecoverPasswordPage
